module.exports = __webpack_public_path__ + "static/media/facebook.a6bc31a2.svg";